import { type ThemeProps } from '~/_shared/types/themeProps';
import { MaptiveChartType } from './chartsVisualizer.types';

// The library we are using utilises the chart.js library.
// The returned object is typed directly according to the chart.js docu https://www.chartjs.org/docs/latest/general/options.htmlconst chartOptionsStyle = ({ theme }: ThemeProps) => {
const chartOptionsStyle = ({ theme }: ThemeProps) => {
  return {
    plugins: {
      legend: {
        labels: { // the legend label
          color: theme.textColors.primary,
        },
      },
    },
  };
};

const spiderWebChartOptionsStyle = ({ theme }: ThemeProps) => {
  const basicOptions = chartOptionsStyle({ theme });
  const spiderWebScaleOptions = {
    r: {
      angleLines: {
        color: theme.lineColors.basePrimary, // the main lines of the "web"
      },
      grid: {
        color: theme.lineColors.basePrimary, // the spiral lines of the "web"
      },
      pointLabels: {
        color: theme.textColors.primary, // the labels at the "web"
      },
      ticks: { // the numbers marking each spiral line of the "web"
        color: theme.textColors.primary,
        backdropColor: theme.backgroundColors.primary,
      },
    },
  };

  return {
    ...basicOptions,
    scales: {
      ...spiderWebScaleOptions,
    },
  };
};

const barChartOptionsStyle = ({ theme }: ThemeProps) => {
  const gridLineOptions = {
    grid: {
      color: theme.lineColors.basePrimary, // the color of the line
    },
    ticks: {
      color: theme.textColors.primary, // the numbers marking each line
    },
  };

  return ({
    ...chartOptionsStyle({ theme }),
    scales: {
      x: gridLineOptions,
      y: gridLineOptions,
    },
  });
};

const horizontalBarChartOptionsStyle = ({ theme }: ThemeProps) => ({
  ...barChartOptionsStyle({ theme }),
  indexAxis: 'y' as const,
});

export const CHART_OPTIONS_STYLE_BY_TYPE: Record<MaptiveChartType, (props: ThemeProps) => Record<string, unknown>> = {
  [MaptiveChartType.DoughnutChart]: chartOptionsStyle,
  [MaptiveChartType.PieChart]: chartOptionsStyle,
  [MaptiveChartType.PolarAreaChart]: spiderWebChartOptionsStyle,
  [MaptiveChartType.RadarChart]: spiderWebChartOptionsStyle,
  [MaptiveChartType.VerticalBarChart]: barChartOptionsStyle,
  [MaptiveChartType.HorizontalBarChart]: horizontalBarChartOptionsStyle,
};
